import React from "react";
import {
  Assignment,
  AssignmentInd,
  SettingsApplications,
  Person,
  VerifiedUser,
  GroupWork,
} from "@material-ui/icons";

export const CONSENT_TYPES = [
  { value: "-", label: "Nessun tipo" },
  {
    value: "CAMPAIGN-RULES",
    label: "Regolamento campagna",
    icon: <Assignment />,
  },
  {
    value: "SERVICE-RULES",
    label: "Termini di servizio",
    icon: <SettingsApplications />,
  },
  {
    value: "PRIVACY",
    label: "Privacy",
    icon: <VerifiedUser />,
  },
  {
    value: "DIR-MARKETING",
    label: "Marketing",
    icon: <AssignmentInd />,
  },
  {
    value: "INDIR-MARKETING",
    label: "Marketing terze parti",
    icon: <AssignmentInd />,
  },
  {
    value: "PROFILING",
    label: "Profilazione",
    icon: <Person />,
  },
  {
    value: "COOKIE",
    label: "Cookie banner",
    icon: <GroupWork />,
  },
];
